import getSchedules from './getSchedules';
import selecteDeselectSchedule, {
    getSelectedSchedules,
    selectAllSchedules,
} from './selectSchedule';

import selectSchedulesByCategory, {
    selectSchedulesByCategoryData,
} from './selectSchedulesByCategory';

export const actions = {
    getSchedules,
    selecteDeselectSchedule,
    selectAllSchedules,
    getSelectedSchedules,
    selectSchedulesByCategory,
    selectSchedulesByCategoryData,
};

export default actions;
